export enum EServicePriceType {
  FIXED = 0,
  VARIES = 1,
  STARTS_FROM = 2,
  AUTO_CALCULATED = 3,
}